(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[808],{

/***/ 93843:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[workspaceId]",
      function () {
        return __webpack_require__(36252);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TeamPage": function() { return /* binding */ TeamPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _typevid_ui_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66583);
/* harmony import */ var _typevid_ui_pages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34735);




var TeamPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typevid_ui_pages__WEBPACK_IMPORTED_MODULE_3__/* .Dashboard */ .A, {});
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_typevid_ui_shared__WEBPACK_IMPORTED_MODULE_2__/* .withProtectRoute */ .t8)(TeamPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [450,606,97,774,888,179], function() { return __webpack_exec__(93843); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);